import { Button, Container, ListItemButton, ListItemText } from "@mui/material";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setBreadcumbs, setIsShowBack, setTitle } from "../../../containers/containers.reducer";
import CustomTable from "../../../shared/CustomTable";
import checkAccess from "../../../shared/checkAccess";
import CustomModal from "../../../shared/CustomModal";
import ReportHolidayRequestEdit from "./ReportHolidayRequestEdit";
import Swal from "sweetalert2";
import { deleteHolidayRequest } from "../../holiday/holiday.api";
import notificationSuccess from "../../../shared/notificationSuccess";
import notificationError from "../../../shared/notificationError";

export default function ReportHolidayRequest() {

    const dispatch = useDispatch()

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [timeGetData, setTimeGetData] = useState<any>(undefined)

    useEffect(() => {
        dispatch(setTitle("Report"))
        dispatch(setIsShowBack(false))
        dispatch(setBreadcumbs([
            {
                name: "Report",
                url: ""
            },
            {
                name: "Holiday Request Report",
                url: "/report/holidayrequest"
            }
        ]))
    }, [])

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            setTimeGetData(new Date().getTime())
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteHolidayRequest(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete holidayRequest")
                                setTimeGetData(new Date().getTime())
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    return (
        <Container maxWidth='xl'>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit Holiday Request"
                component={
                    <ReportHolidayRequestEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/report/holidayrequest"}
                filterDate={true}
                columns={[
                    {
                        name: "Employee",
                        key: "employee_name"
                    },
                    {
                        name: "Request Date",
                        key: "ts_created",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.ts_created ? moment(props.data.ts_created).format('DD-MM-YYYY hh:mm:ss') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Holiday Date",
                        key: "request_date",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.request_date ? moment(props.data.request_date).format('DD-MM-YYYY') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Notes",
                        key: "notes"
                    },
                    {
                        name: "Status",
                        key: "status_name"
                    }
                ]}
                export={true}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                rowActionsAdditional={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") && (
                            <Button variant="contained" onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                Edit
                            </Button>
                        )}
                    </Fragment>
                )}
                timeGetData={timeGetData}
            />
        </Container>
    )
}